import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Checkbox, DropdownMenu, TextButton, Typography } from 'seagull';
import { ChevronDown } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
import { getEditDropdownRecipientTypeText, getRecipientTypesText, handleSetRecipientTypes, notificationSettingsTextsPath } from '../../../NotificationSettings.utils';
import { GetRecipientsDropdownTID } from './RecipientsDropdown.testIds';
export const RecipientsDropdown = (param)=>{
    let { notificationName, recipientTypes, recipientTypeOptions, onChange } = param;
    const { RecipientsDropdownTestIds: testIds } = useMemo(()=>GetRecipientsDropdownTID(), []);
    const { t: notifTexts } = useLocaleKeys(notificationSettingsTextsPath);
    const { t: contentTexts } = useLocaleKeys('pages.notificationSettings.contentCustomization');
    const recipientLabel = getRecipientTypesText({
        recipientTypes,
        notificationName,
        texts: notifTexts
    }).join(', ');
    const optionLabels = getEditDropdownRecipientTypeText({
        notificationName,
        texts: notifTexts
    });
    const trigger = /*#__PURE__*/ _jsx(TextButton, {
        weight: "bold",
        underline: "none",
        suffixIcon: /*#__PURE__*/ _jsx(ChevronDown, {}),
        bi: {
            name: 'notify_recipients'
        },
        testId: testIds.Trigger(),
        children: recipientLabel || contentTexts.notifyRowLabel()
    });
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        hAlign: "left",
        maxHeight: "50%",
        target: trigger,
        children: recipientTypeOptions.map((type)=>/*#__PURE__*/ _jsx(DropdownMenu.Item, {
                bi: {
                    name: 'notification_recipient_option'
                },
                as: Checkbox,
                closeOnClick: false,
                checked: recipientTypes.includes(type),
                onChange: (event)=>handleSetRecipientTypes({
                        newType: type,
                        newRecipientTypes: event.currentTarget.checked ? [
                            ...recipientTypes,
                            type
                        ] : recipientTypes.filter((current)=>current !== type),
                        setRecipientTypes: onChange
                    }),
                testId: testIds.Option(type),
                children: /*#__PURE__*/ _jsx(Typography, {
                    children: optionLabels[type]
                })
            }, type))
    });
};
